import React, { useEffect, useMemo } from "react";

import * as actions from "../../../_redux/invoices/invoicesActions";

import * as uiHelpers from "./../InvoicesUIHelpers";
import { useInvoicesUIContext } from "../InvoicesUIContext";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  getHandlerTableChange,
  getSelectRow,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../_metronic/_helpers";
import * as formatters from "./column-formatters/index";

export function InvoicesTable() {
  const { user } = useSelector((state) => state.auth);

  const invoicesUIContext = useInvoicesUIContext();

  const invoicesUIProps = useMemo(() => {
    return {
      queryParams: invoicesUIContext.queryParams,
      setQueryParams: invoicesUIContext.setQueryParams,
      viewInvoiceButtonClick: invoicesUIContext.viewInvoiceButtonClick,
      deleteInvoiceButtonClick: invoicesUIContext.deleteInvoiceButtonClick,
    };
  }, [invoicesUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.invoices }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchInvoices(invoicesUIProps.queryParams));
  }, [invoicesUIProps.queryParams, dispatch]);

  const columns = [
    {
      dataField: "branchName",
      text: "نام شعبه",
      formatter: formatters.NameLinkFormatter,
    },
    {
      dataField: 'description',
      text: 'توضیحات'
    },
    {
      dataField: "createDate",
      text: "تاریخ فاکتور",
      formatter: formatters.DateColumnFormatter,
    },
    {
      dataField: "amount",
      text: "مبلغ فاکتور",
      formatter: formatters.PriceColumnFormatter,
    },
    {
      dataField: 'status',
      text: 'وضعیت پرداخت',
      formatter: formatters.InvoiceStatusFormatter,
    },
    {
      dataField: "action",
      text: "عملیات",
      formatter: formatters.ActionsColumnFormatter,
      formatExtraData: {
        viewInvoiceButtonClick: invoicesUIProps.viewInvoiceButtonClick,
        deleteInvoiceButtonClick: invoicesUIProps.deleteInvoiceButtonClick,
        user,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: invoicesUIProps.queryParams.pageSize,
    page: invoicesUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => (
          <Pagination isLoading={listLoading} paginationProps={paginationProps}>
            <BootstrapTable
              wrapperClasses={"table-responsive"}
              bordered={false}
              classes={
                "table table-head-custom table-vertical-header overflow-hidden"
              }
              bootstrap4
              remote
              keyField={"id"}
              data={entities === null ? [] : entities}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                invoicesUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        )}
      </PaginationProvider>
    </>
  );
}
